export const documentType = {
	Unknown: 0,
	Invoice: 10,
	Statement: 20,
};
